import * as _ from 'lodash';
import RHFSelect from 'src/components/controls/tempRHFControls/RHFSelect';
import React, { useState, useEffect, FormEvent } from 'react';
import { useForm } from 'react-hook-form';
import { FaPenSquare } from 'react-icons/fa';
import { FiDelete } from 'react-icons/fi';
import { ODataOptions, ODataFilter, ODataFilterOperators, ODataOrderByDirection } from 'src/util/ODataBuilder';
import { ITableConfig } from 'src/components/common/table';
import useFetch from 'use-http';
import PBNavBar from '../PBNavBar';
import { MdEmail } from 'react-icons/md';
// import { MdRefresh } from 'react-icons/md';
import RHFInputBox from 'src/components/controls/tempRHFControls/RHFInputBox';
import Page from 'src/components/common/Page';
import Panel from 'src/components/common/Panel';
import Button from 'src/components/controls/forms/redesign/FormButton';
import ClientProjectSearch from 'src/components/project-billing/components/ClientProjectSearch';
import { BiAddToQueue } from 'react-icons/bi';
import PayPeriod from 'src/models/AP/PayPeriod';
import TimeAndExpenseChecklist from 'src/models/projectSettings/TsdiTneChecklist';
import { FaSortAlphaDown, FaSortAlphaUp } from 'react-icons/fa';
import OfficeTimeAndExpenseEntries from 'src/models/AP/OfficeTimeAndExpenseEntries';
import LoadingSpinner from 'src/components/common/LoadingSpinner';
import TimeEntryForm from 'src/models/AP/TimeEntryForm';
import TEData from 'src/models/AP/TEData';
import CalendarDay from 'src/models/AP/CalendarDay';
import BillingSummary from 'src/models/AP/BillingSummary';
import { FiChevronDown } from 'react-icons/fi';
// import Tooltip from 'react-tooltip-portal';
import ProspectDetails from 'src/models/projectSettings/TsdiProspect';
// import AccountCodeContainer from 'src/models/AP/AccountCodeContainer';
import { UserRoles } from 'src/models/UserRole';
import TsdiSubcode from 'src/models/AP/Subcode';
import { AnyObject } from 'final-form';
import { AppContext } from 'src/providers/AppContextProvider';
import { IAppContextState } from 'src/reducers/AppContext';
import ErrorResponse from 'src/models/ErrorResponse';
import { PDFDownloadLink } from '@react-pdf/renderer';
import TimesheetDocument, { ITimesheetData } from '../components/TimeAndExpenseTimesheet';
import SummaryDocument from '../components/TimeAndExpenseSummary';
import RefreshIcon from '../components/RefreshIcon';
import DayEntry from 'src/models/AP/DayEntry';
import EditDayEntry from 'src/models/AP/EditDayEntry';
import WorkAndExpenseDialog from '../dialogs/WorkDescriptionsAndExpensesDialog';
import WarningDialog from 'src/components/accounts-payable/dialogs/WarningDialog';
import { useDispatch } from 'react-redux';
import actions from 'src/actions';
import DialogList from 'src/dialogs';
import BillingCode from 'src/models/AP/BillingCode';
import { PDEResquestType, useServiceCtx } from '../components/TimeAndExpenseServiceContext';
import ReceiptViewerDialog from 'src/components/client-project/dialogs/ReceiptViewerDialog';
import Receipt from '../models/Receipt';
import DocumentSourceType from '../models/DocumentSourceType';
import Summary from '../models/Summary';
import FlagNoteDialog from '../dialogs/FlagNoteDialog';

const TimeAndExpensePageComponent = () => {
    const dispatch = useDispatch();
    const [selectedProject, setSelectedProject] = useState<ProspectDetails>(undefined);
    const appContext = React.useContext<IAppContextState>(AppContext);
    const [selectedSubcode, setSelectedSubcode] = useState<TsdiSubcode>(undefined);
    const { register, handleSubmit, setValue, reset, getValues, formState } = useForm();
    const { isDirty, dirtyFields } = formState;
    const { reset: resetSearchOptions, register: registerSearchOptions, setValue: setSearchOptionsValue, getValues: getSearchOptionsValues } = useForm();
    const { register: registerTimeEntries, reset: resetTimeEntries, errors: timeEntriesErrors } = useForm();
    const { get, /*post,*/ response } = useFetch();
    const [loadingTimeEntries, setLoadingTimeEntries] = useState<boolean>(true);
    const [payPeriods, setPayPeriods] = useState<Array<PayPeriod>>(undefined);
    const [selectedPayPeriod, setSelectedPayPeriod] = useState<string>(undefined);
    const [sortDlcNumber, setSortDlcNumber] = useState<boolean>(true);
    const [sortName, setSortName] = useState<boolean>(true);
    const [sortTkprs, setSortTkprs] = useState<boolean>(true);
    const [sortLastDate, setSortLastDate] = useState<boolean>(true);
    const [sortTotal, setSortTotal] = useState<boolean>(true);
    const [sortDays, setSortDays] = useState<boolean>(true);
    const [sortAprs, setSortAprs] = useState<boolean>(true);
    const [sortExpenses, setSortExpenses] = useState<boolean>(true);
    const [officeTimeEntries, setOfficeTimeEntries] = useState<Array<OfficeTimeAndExpenseEntries>>([]);
    const [timeEntries, setTimeEntries] = useState<Array<TimeAndExpenseChecklist>>([]);
    const [unsavedChanges, setUnsavedChanges] = useState<boolean>(false);
    const [loadingPage, setLoadingPage] = useState<boolean>(true);
    const [payPeriodLocked, setPayPeriodLocked] = useState<boolean>(false);
    // const postSaveUpdateIndex = useRef(-1);
    const [payPeriodValidation, setPayPeriodValidation] = useState(false);
    const [hasInvoice, setHasInvoice] = useState<boolean>(false);
    const [timeExpenseToken, setTimeExpenseToken] = useState<string>(undefined);
    const [delegatedDlcNumber, setDelegatedDlcNumber] = useState<number>(undefined);
    const [dlcNumber, setDlcNumber] = useState<number>(undefined);
    // const [loggedInUser, setLoggedInUser] = useState<string>(undefined);
    const [periodCutoffDate, setPeriodCutoffDate] = useState<Date>(undefined);
    const [timeExpenseData, setTimeExpenseData] = useState<void | Object>(undefined);
    const [userRole, setUserRole] = useState('');
    const [formData, setFormData] = useState<TimeEntryForm | undefined>(undefined);
    const [billingSummary, setBillingSummary] = useState<Array<BillingSummary>>(undefined);
    const [data, setData] = useState<TEData | undefined>(undefined);
    const [calendarDays, setCalendarDays] = useState<CalendarDay[]>(undefined);
    const [compensationType, setCompensationType] = useState('');
    const [selectedIndex, setSelectedIndex] = useState<number>(0);
    const [showDeleteWarning, setShowDeleteWarning] = useState<object>(null);
    const [confirmDeleteDayEntry, setConfirmDeleteDayEntry] = useState<boolean>(null);
    const [showWorkExpenseDialog, setShowWorkExpenseDialog] = useState<object>(null);
    const [showError, setShowError] = useState<Array<Array<AnyObject>>>([[{}]]);
    const [tsdiAccounts, setTsdiAccounts] = useState<Array<{ code: number, description: string}>>(undefined);
    const isAdminUser = appContext.currentUser.role === UserRoles.AccountingAdmin ||
      appContext.currentUser.role === UserRoles.HRAdmin || appContext.currentUser.role === UserRoles.Admin;
    const prototypeOfficeExpenseId = 1043255;
    const [receiptThumbnails, setReceiptThumbnails] = useState<Array<Receipt>>(undefined);
    const {
      createDayEntry,
      deleteDayEntry,
      validateBillingCode,
      getTimePeriodCutoffDate
    } = useServiceCtx();

    const sampleSummary: Summary[] = [{
      clientName: 'East Stanbrook, LLC',
      employeeName: 'Amy Harris',
    }];
    const sampleData: ITimesheetData = {
      name: 'Gaddis, Skyelar',
      dlc: '6706',
      payPeriod: '2025-02',
      statements: [
        {
          project: 'Project Raptor',
          projectNumber: '843.906',
          entries: [
            {
              date: '01/16/2025',
              days: '1.000',
              miles: '0',
              mileage: '0.00',
              meals: '0.00',
              motel: '0.00',
              copies: '0.00',
              phone: '0.00',
              abstractFees: '0.00',
              postage: '0.00',
              shipping: '0.00',
              other: '0.00',
              total: '0.00',
              description: 'Lease Checking for Fairway East. Review of STRs and calculation of acreages.'
            },
            {
              date: '01/17/2025',
              days: '1.000',
              miles: '0',
              mileage: '0.00',
              meals: '0.00',
              motel: '0.00',
              copies: '0.00',
              phone: '0.00',
              abstractFees: '0.00',
              postage: '0.00',
              shipping: '0.00',
              other: '0.00',
              total: '0.00',
              description: 'Lease Checking for Fairway East. Continued review of STRs.'
            },
            {
              date: '01/21/2025',
              days: '1.000',
              miles: '0',
              mileage: '0.00',
              meals: '0.00',
              motel: '0.00',
              copies: '0.00',
              phone: '0.00',
              abstractFees: '0.00',
              postage: '0.00',
              shipping: '0.00',
              other: '0.00',
              total: '0.00',
              description: 'Lease Checking for Fairway, BLM & SITLA Open Leases lands search and data entry.'
            }
          ],
          totals: {
            days: '3.000',
            miles: '0',
            mileage: '0.00',
            meals: '0.00',
            motel: '0.00',
            copies: '0.00',
            phone: '0.00',
            abstractFees: '0.00',
            postage: '0.00',
            shipping: '0.00',
            other: '0.00',
            total: '0.00'
          }
        },
        {
          project: 'Project Titan Central',
          projectNumber: '1065.3',
          entries: [
            {
              date: '01/30/2025',
              days: '0.375',
              miles: '0',
              mileage: '0.00',
              meals: '13.00',
              motel: '0.00',
              copies: '0.00',
              phone: '0.00',
              abstractFees: '0.00',
              postage: '0.00',
              shipping: '0.00',
              other: '13.00',
              total: '13.00',
              description: 'Notification List update for 4176-2833.'
            }
          ],
          totals: {
            days: '0.375',
            miles: '0',
            mileage: '0.00',
            meals: '13.00',
            motel: '0.00',
            copies: '0.00',
            phone: '0.00',
            abstractFees: '0.00',
            postage: '0.00',
            shipping: '0.00',
            other: '13.00',
            total: '13.00'
          }
        }
      ],
      recap: {
        totals: {
          days: '3.375',
          miles: '0',
          mileage: '0.00',
          meals: '13.00',
          motel: '0.00',
          copies: '0.00',
          phone: '0.00',
          abstractFees: '0.00',
          postage: '0.00',
          shipping: '0.00',
          other: '13.00',
          total: '13.00'
        },
        projectNumbers: [
          { project: 'Project Raptor', number: '843.906', services: '3,984.38', expenses: '140.63' },
          { project: 'Project Titan Central', number: '1065.3', services: '3,984.38', expenses: '153.63' }
        ],
        hours: '88.000'
      }
    };
        
    // Initial render
    useEffect(() => {
      onCreate();

      return () => {
          onDestroy();
      };
    }, []);

    useEffect(() => {
      if (!!timeEntries) {
          resetTimeEntries(officeTimeEntries);
          setLoadingTimeEntries(false);
      }
    }, [timeEntries]);

    useEffect(() => {
      if (confirmDeleteDayEntry) {
        setTimeout(() => {
          setConfirmDeleteDayEntry(false);
        }, 1000);
      }
    }, [confirmDeleteDayEntry]);

    useEffect(() => {
        if (showDeleteWarning) {
            showDeleteWarningDialog();
        }
    }, [showDeleteWarning]);

    useEffect(() => {
        if (showWorkExpenseDialog) {
            showWorkDescriptionAndExpenseDialog();
        }
    }, [showWorkExpenseDialog]);

    useEffect(() => {
        if (!!payPeriods && payPeriods?.length > 0) {
            const storedPayperiod = localStorage.getItem('backOfficeSelectedPayPeriod');
            if (!!storedPayperiod) {
                setSelectedPayPeriod(storedPayperiod);
                const storedLandmanNumber = localStorage.getItem('backOfficeSelectedLandman');
                if (!!storedLandmanNumber && !isNaN(Number(storedLandmanNumber))) {
                    if (!timeExpenseToken) {
                        getTimeAndExpenseToken();
                    } else {
                        getTimeSheetForOtherUser(storedPayperiod, Number(storedLandmanNumber));
                        setDelegatedDlcNumber(!isNaN(Number(storedLandmanNumber)) ? Number(storedLandmanNumber) : undefined);
                    }
                }
            }
        }
    }, [payPeriods]);

    useEffect(() => {
        if (!!selectedPayPeriod && selectedPayPeriod.length > 0) {
            localStorage.setItem('backOfficeSelectedPayPeriod', selectedPayPeriod);
            const insertIndex = selectedPayPeriod.length - 2;
            const ppString = insertCharAt(selectedPayPeriod, '-', insertIndex);
            const payperiodSearchData = getSearchOptionsValues();
            console.log(payperiodSearchData);
            resetSearchOptions({ payPeriod: ppString, dlcNumber: !!delegatedDlcNumber ? delegatedDlcNumber : (!!dlcNumber ? dlcNumber : '')});
        }
    }, [selectedPayPeriod]);

    useEffect(() => {
        if (!!billingSummary && billingSummary.length > 0) {
            let newFormData = mapArrayToDayTotals(calendarDays);
            reset({ ...newFormData, day1TotalHours: calendarDays[0]?.totalHours, summary: billingSummary, totalHours: (timeExpenseData as { totalHours: number})?.totalHours });
            // setValue(`day${1}TotalHours`, calendarDays[1].totalHours);
            let ppString = '';
            if (!!selectedPayPeriod && selectedPayPeriod.length > 2) {
              const insertIndex = selectedPayPeriod.length - 2;
              ppString = insertCharAt(selectedPayPeriod, '-', insertIndex);
            }

            resetSearchOptions({ payPeriod: ppString, dlcNumber: !!delegatedDlcNumber ? delegatedDlcNumber : (!!dlcNumber ? dlcNumber : '')});
        }
    }, [billingSummary]);

    useEffect(() => {
      if (!!dlcNumber && !isNaN(Number(dlcNumber))) {
        setSearchOptionsValue('dlcNumber', dlcNumber.toString());
      }
  }, [dlcNumber]);

    useEffect(() => {
        if (!!calendarDays && calendarDays.length > 0) {
            populateTimeEntryForm();
        }
    }, [calendarDays]);

    useEffect(() => {
        if (!!timeExpenseData) {
            setCalendarDays((timeExpenseData as {calendarDays: CalendarDay[]}).calendarDays);
            setValue('totalHours', (timeExpenseData as { totalHours: number }).totalHours);
        }
    }, [timeExpenseData]);

    useEffect(() => {
        if (!!timeExpenseToken && timeExpenseToken.length > 0) {
          const decodedJwt =  decodeJwtPayload(timeExpenseToken);
          const tsdiNumber = decodedJwt.tn;
          if (!isNaN(Number(tsdiNumber))) {
            setDlcNumber(Number(tsdiNumber));
          }
          const storedLandmanNumber = localStorage.getItem('backOfficeSelectedLandman');
          const storedPayperiod = localStorage.getItem('backOfficeSelectedPayPeriod');
          if (!!storedLandmanNumber && !isNaN(Number(storedLandmanNumber)) && !!storedPayperiod && !isNaN(Number(storedPayperiod))) {
              getTimeSheetForOtherUser(storedPayperiod, Number(storedLandmanNumber));
              getTimePeriodCutoffDate(storedPayperiod, Number(storedLandmanNumber)).then((result) => {
                setPeriodCutoffDate(result as Date);
              });
              setDelegatedDlcNumber(!isNaN(Number(storedLandmanNumber)) ? Number(storedLandmanNumber) : undefined);
          } else {
            getTimeAndExpenseData(tsdiNumber);
          }
        }
    }, [timeExpenseToken]);

    const onCreate = () => {
        // Put all initialization code here.
        getOfficeExpenseReceiptsThumbnails();
        setSelectedProject(new ProspectDetails());
        setSelectedSubcode(new TsdiSubcode());
        setLoadingPage(false);
        setPayPeriodLocked(false);
        setPayPeriodValidation(false);
        setHasInvoice(false);
        setUserRole(!!isAdminUser ? 'ad' : 'e');
        setFormData(new TimeEntryForm());
        setData(new TEData());
        setCalendarDays([
            { id: 1, dayType: 2, dayName: 'Mon', dateTime: new Date(), friendlyDate: null },
            { id: 2, dayType: 1, dayName: 'Tue', dateTime: new Date(+1), friendlyDate: null },
            { id: 3, dayType: 3, dayName: 'Wed', dateTime: new Date(+2), friendlyDate: null },
            { id: 4, dayType: 1, dayName: 'Thu', dateTime: new Date(+3), friendlyDate: null },
            { id: 5, dayType: 1, dayName: 'Fri', dateTime: new Date(+4), friendlyDate: null },
            { id: 6, dayType: 1, dayName: 'Sat', dateTime: new Date(+5), friendlyDate: new Date() },
            { id: 7, dayType: 1, dayName: 'Sun', dateTime: new Date(+6), friendlyDate: new Date() },
            { id: 8, dayType: 1, dayName: 'Mon', dateTime: new Date(+7), friendlyDate: new Date() }
        ]);
        setCompensationType('H');
        getPayPeriods();
        getBillingAccounts();
        setShowError([]);
    };
    
    const mapArrayToDayTotals = (sourceArray: CalendarDay[]): Record<string, number | null | undefined> => {
      const result: Record<string, number | null | undefined> = {};
    
      sourceArray.forEach((item, index) => {
        const key = `day${index + 1}TotalHours`;
        result[key] = item.totalHours ?? null;
      });
    
      return result;
    };

    const hideWorkExpenseDialogAndRefreshData = () => {
      hideDialog();
      handlePayPeriodNav();
    };

    const transformToBillingSummaries = (): BillingSummary[] => {
      if (!calendarDays || calendarDays.length === 0) {
        return [];
      }
    
      const MAX_DAYS = 16;
      const makeBaseKey = (entry: DayEntry) =>
        [
          entry.clientNumber ?? 'null',
          entry.prospectNumber ?? 'null',
          entry.sectionNumber ?? 'null',
          entry.unitNumber ?? 'null',
          entry.selectedAccountCodeContainer?.name ?? ''
        ].join('|');
    
      // Step 1: Group day entries by baseKey, per calendar day
      const grouped: Record<string, Array<Array<DayEntry>>> = {};
    
      calendarDays.forEach((calDay, dayIndex) => {
        if (!calDay.dayEntries) {
          return;
        }
    
        calDay.dayEntries.forEach(entry => {
          const bk = makeBaseKey(entry);
          grouped[bk] = grouped[bk] ?? [];
    
          // ensure there is a subarray for this dayIndex
          while (grouped[bk].length <= dayIndex) {
            grouped[bk].push([]);
          }
    
          grouped[bk][dayIndex].push(entry);
        });
      });
    
      const summaries: BillingSummary[] = [];
    
      // Step 2: For each baseKey, create rows up to the maximum number of entries in any day
      Object.entries(grouped).forEach(([bk, daysEntries]) => {
        const maxRows = Math.max(...daysEntries.map(d => d.length));
    
        for (let rowIndex = 0; rowIndex < maxRows; rowIndex++) {
          const summary = new BillingSummary();
    
          // populate identity fields from the first available entry
          let firstEntry: DayEntry | undefined;
          for (const day of daysEntries) {
            if (day[rowIndex]) {
              firstEntry = day[rowIndex];
              break;
            }
          }
          if (!firstEntry) {
            continue;
          }
    
          summary.clientNumber = firstEntry.clientNumber ?? null;
          summary.prospectNumber = firstEntry.prospectNumber ?? null;
          summary.sectionNumber = firstEntry.sectionNumber ?? null;
          summary.unitNumber = firstEntry.unitNumber ?? null;
    
          summary.clientName = firstEntry.clientName;
          summary.prospectName = firstEntry.prospectName;
          summary.sectionName = firstEntry.sectionName;
          summary.unitName = firstEntry.unitName;
    
          summary.workClassificationName =
            firstEntry.selectedAccountCodeContainer?.code.toString() ?? '';
    
          summary.tmIds = [];
    
          // track row total by summing dayXHours
          let rowTotal = 0;
    
          // populate dayXHours
          for (let dayIndex = 0; dayIndex < Math.min(daysEntries.length, MAX_DAYS); dayIndex++) {
            const dayKey = `day${dayIndex + 1}Hours` as keyof BillingSummary;
            const entry = daysEntries[dayIndex][rowIndex];
    
            if (entry) {
              const hours = entry.hours ?? 0;
              (summary as Record<string, number | null | undefined>)[dayKey] = entry.hours ?? null;
              rowTotal += hours;
    
              if (entry.tmId != null) {
                summary.tmIds.push(entry.tmId);
              // } else if (!summary.tmIds.includes(null)) {
              } else {
                summary.tmIds.push(null);
              }
            } else {
              (summary as Record<string, number | null | undefined>)[dayKey] = null;
              summary.tmIds.push(null);
            }
          }
    
          // assign row total as sum of all dayXHours
          summary.totalHours = rowTotal;
    
          summaries.push(summary);
        }
      });
    
      return summaries;
    };

    const showDialog = (dialog: DialogList) => {
        dispatch(actions.layout.showDialog(dialog));
    };
          
    const populateTimeEntryForm = () => {
        // Convert the map to an array and update state
        const transformedData = Array.from(transformToBillingSummaries());
        setBillingSummary(transformedData);
    };  
  
    const TE_URL = process.env.REACT_APP_BASE_TE_API_URL;
    const CURRENT_PAY_PERIOD = 'api/v2/PayPeriod/currentpayperiod/';
    const ADMIN_NAV_URL = 'api/v2/payPeriodForAdmin/';
    const APPROVE_TIMESHEET = 'api/v2/entry/approveTimesheet';    
    const EDIT_DAY_ENTRY = 'api/v2/entry/edit';

    const handleApiError = (value: Response) => {
        console.log('api call failed: ' + value);
    };

    const handleApiCall = (value: Response) => {
        return new Promise<object>((resolve) => {
            if (value.ok) {
                value
                    .json()
                    .then((body) => resolve(body))
                    .catch(() => resolve(null));
            } else {
                resolve(value.json().then((errorResponse: ErrorResponse) => new ErrorResponse(errorResponse.messageCode, errorResponse.message)));
            }
        });
    };

    const createHeader = (type: string) => {
        let headers = {};

        // let jwtToken = getJwtToken();
        // jwt = undefined;

        const username = `Joe Example`;
        const password = `DudleyRocks025!`;
        if (type === 'jwt') {
            headers = {
                'un': `${username}`,
                'pw': `${password}`,
                // 'Connection': 'keep-alive',
                // 'content-type': 'application/json',
                // Authorization: `Bearer ${jwt}`,
            };
        } else if (type === 'validateProspect') {
            headers =  {
                'Tsjwt': timeExpenseToken,
                'content-type': 'application/json'
              };
        } else if (type === 'getTeData') {
            headers =  {
                'Tsjwt': timeExpenseToken,
                'content-type': 'application/json'
              };
        } else {
            headers = {
                'un': `${username}`,
                'pw': `${password}`,
                'content-type': 'application/json' };
        }

        return headers;
    };

    const getRequest = async (url: string, jwt: string | undefined = undefined) => {
        return fetch(url, getHeader(jwt)).then(handleApiCall).catch(handleApiError);
    };

    const postHeader = (body: object, jwt: string | undefined = undefined) => {
      const header: RequestInit = {
          body: JSON.stringify(body),
          headers: createHeader('validateProspect'),
          method: 'POST',
          mode: 'cors',
      };
      return header;
    };

    const postRequest = async (url: string, body: object, jwt: string | undefined = undefined) => {
        return fetch(url, postHeader(body, jwt)).then(handleApiCall).catch(handleApiError);
    };

    const getHeader = (jwt: string | undefined) => {
        const header: RequestInit = {
            headers: createHeader(jwt),
            method: 'GET',
            mode: 'cors',
        };
        return header;
    };

    const approveTimesheet = async (payPeriod: number, tsdNumber: number, proofedBy: string) => {
      const payload = {
          'TSD_NO': tsdNumber,
          'PERIOD_NO': payPeriod,
          'P_PROOF_BY': proofedBy};
      let apResponseData = await postRequest(`${TE_URL}${APPROVE_TIMESHEET}`, payload as object, 'validateProspect');
      if (response.ok && (apResponseData as unknown as number) === 0) {
          console.log('========> Received response from T&E Service', apResponseData);
      } else {
        console.log('Unable to approve time sheet.');
      }
    };

    const getBillingAccounts = async () => {
        let result = await get(`/v1.0/AccountsPayable/billing/accounts`);

        if (response.ok) {
            setTsdiAccounts(result);
        } else {
            console.log('Unable to get Billing Accounts Data!!!');
        }
    };

    const getTimesheetReportFile = async (outputType: number) => {
      const timePeriod = !!selectedPayPeriod ? selectedPayPeriod : null;
      const employeeId = !!delegatedDlcNumber ? delegatedDlcNumber : (!!dlcNumber ? dlcNumber : null);
      if (!!timePeriod && !!employeeId) {
        await get(`v1.0/reports/GetReport/${outputType}/timesheet/timeperiod/${timePeriod}/employeeId/${employeeId}`);
        if (response.ok) {
            await response.blob().then((blob) => {
                const blobUrl = window.URL.createObjectURL(blob);
                const a = document.getElementById('timesheetReport') as HTMLAnchorElement;
                a.href = blobUrl;
                a.download = outputType === 1 ? `${timePeriod}-${employeeId}-Timesheet.xlsx` : `${timePeriod}-${employeeId}-Timesheet.pdf`;
                a.click();
                window.URL.revokeObjectURL(blobUrl);
            });
        }
      } else {
        alert('No time period and/or employeeId selected!');
      }
    };
    /* const getSummaryFile = async () => {

    } */
    const editDayEntry = async (body: EditDayEntry) => {
        const result = await postRequest(`${TE_URL}${EDIT_DAY_ENTRY}`, body);
  
        if (response.ok && (!(result as {error: string})?.error || (result as {error: string})?.error?.length === 0)) {
          setTimeExpenseData(result);
        } else {
            console.log('Unable to get T&E data!');
        }
    };

    const getTimeSheetForOtherUser = async (period: string, tsdiNumber: number) => {
        let result = await getRequest(`${TE_URL}${ADMIN_NAV_URL}${period}/otheremployee/${tsdiNumber}`, 'getTeData');
        if (response.ok && (!(result as {error: string})?.error || (result as {error: string})?.error?.length === 0)) {
            setTimeExpenseData(result);
        } else {
            console.log('Unable to get T&E data!');
        }
    };

    const getTimeAndExpenseData = async (tsdiNumber: number) => {
        let result = await getRequest(`${TE_URL}${CURRENT_PAY_PERIOD}${tsdiNumber}`, 'getTeData');
        if (response.ok && (!(result as {error: string})?.error || (result as {error: string})?.error?.length === 0)) {
            setTimeExpenseData(result);
            const responsePayPeriod = (result as {name: string}).name.replace('-', '');
            setSelectedPayPeriod(responsePayPeriod);
            if (!delegatedDlcNumber) {
              handlePayPeriodNav();
            }
        } else {
            console.log('Unable to get T&E data!');
        }
    };    

    const decodeJwtPayload = (token: string) => {
        try {
            const payload = token.split('.')[1];
            const base64 = payload.replace(/-/g, '+').replace(/_/g, '/');
            const jsonPayload = decodeURIComponent(
            atob(base64)
                .split('')
                .map(c => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
                .join('')
            );
            return JSON.parse(jsonPayload);
        } catch (e) {
            console.log('Invalid JWT token');
            return null;
        }
    };

    const getTimeAndExpenseToken = async () => {
        let userName = appContext.currentUser.username;
/*         if (userName === 'crestonperkins@dudley-land.com') {
            userName = 'Creston%20Perkins';
        } */

        const result = await get(`v1.0/reports/time-expense-token/user/${userName}`);
        if (response.ok) {
            try {
                    const jwtObject = JSON.parse(result);                
                    setTimeExpenseToken(jwtObject.timeAndExpenseJwt);
                } catch (error) {
                    console.log('Invalid JSON string:', error);
                }
        } else {
            console.log('Unable to get T&E token!');
        }
    };

    const insertCharAt = (str: string, charToInsert: string, index: number) => {
        return str.slice(0, index) + charToInsert + str.slice(index);
    };

    const handleExpensesChanged = (index: number, newValue: string ) => {
        const updated = [...timeEntries];
        updated[index].expenses = parseFloat(newValue) || 0;
        setTimeEntries(updated);
    };

    const handleTotalAmountChanged = (index: number, newValue: string ) => {
        const updated = [...timeEntries];
        updated[index].total = parseFloat(newValue) || 0;
        setTimeEntries(updated);
    };

    type SortOrder = 'ASC' | 'DESC';

    const sortTneChecklist = <T extends keyof TimeAndExpenseChecklist>(
        array: TimeAndExpenseChecklist[],
        key: T,
        order: SortOrder = 'ASC'
    ): TimeAndExpenseChecklist[] =>
        [...array].sort((a, b): number => {
        const valA = a[key];
        const valB = b[key];
    
        if (valA === null && valB === null) {
            return 0;
        }

        if (valA === null) {
            return order === 'ASC' ? 1 : -1;
        }

        if (valB === null) {
            return order === 'ASC' ? -1 : 1;
        }
    
        return typeof valA === 'string' && typeof valB === 'string'
            ? order === 'ASC'
            ? valA.localeCompare(valB)
            : valB.localeCompare(valA)
            : typeof valA === 'number' && typeof valB === 'number'
            ? order === 'ASC'
            ? valA - valB
            : valB - valA
            : valA instanceof Date && valB instanceof Date
            ? order === 'ASC'
            ? valA.getTime() - valB.getTime()
            : valB.getTime() - valA.getTime()
            : order === 'ASC'
            ? String(valA).localeCompare(String(valB))
            : String(valB).localeCompare(String(valA));
        });

    const sortByDlcNumber = () => {        
        setLoadingTimeEntries(true);
        setSortDlcNumber(!sortDlcNumber);
        const newState = !sortDlcNumber;
        let newArray = new Array<TimeAndExpenseChecklist>();
        newArray = [...sortTneChecklist(timeEntries, 'employeeNumber', !!newState ? 'DESC' : 'ASC')];
        setTimeEntries(newArray);
    };
                       
    const sortByName = () => {
        setLoadingTimeEntries(true);
        setSortName(!sortName);
        const newState = !sortName;
        let newArray = new Array<TimeAndExpenseChecklist>();
        newArray = [...sortTneChecklist(timeEntries, 'name', !!newState ? 'DESC' : 'ASC')];
        setTimeEntries(newArray);
    };

    const sortByDays = () => {
        setLoadingTimeEntries(true);
        setSortDays(!sortDays);
        const newState = !sortDays;
        let newArray = new Array<TimeAndExpenseChecklist>();
        newArray = [...sortTneChecklist(timeEntries, 'days', !!newState ? 'DESC' : 'ASC')];
        setTimeEntries(newArray);
    };

    const sortByTkprs = () => {
        setLoadingTimeEntries(true);
        setSortTkprs(!sortTkprs);
        const newState = !sortTkprs;
        let newArray = new Array<TimeAndExpenseChecklist>();
        newArray = [...sortTneChecklist(timeEntries, 'turnkeyProspects', !!newState ? 'DESC' : 'ASC')];
        setTimeEntries(newArray);
    };

    const sortByLastDate = () => {
        setLoadingTimeEntries(true);
        setSortLastDate(!sortLastDate);
        const newState = !sortLastDate;
        let newArray = new Array<TimeAndExpenseChecklist>();
        newArray = [...sortTneChecklist(timeEntries, 'lastDate', !!newState ? 'DESC' : 'ASC')];
        setTimeEntries(newArray);
    };

    const sortByExpenses = () => {
        setLoadingTimeEntries(true);
        setSortExpenses(!sortExpenses);
        const newState = !sortExpenses;
        let newArray = new Array<TimeAndExpenseChecklist>();
        newArray = [...sortTneChecklist(timeEntries, 'expenses', !!newState ? 'DESC' : 'ASC')];
        setTimeEntries(newArray);
    };

    const sortByTotal = () => {
        setLoadingTimeEntries(true);
        setSortTotal(!sortTotal);
        const newState = !sortTotal;
        let newArray = new Array<TimeAndExpenseChecklist>();
        newArray = [...sortTneChecklist(timeEntries, 'expenses', !!newState ? 'DESC' : 'ASC')];
        setTimeEntries(newArray);
    };

    const sortByAprs = () => {
        setLoadingTimeEntries(true);
        setSortAprs(!sortAprs);
        const newState = !sortAprs;
        let newArray = new Array<TimeAndExpenseChecklist>();
        newArray = [...sortTneChecklist(timeEntries, 'approvalCount', !!newState ? 'DESC' : 'ASC')];
        setTimeEntries(newArray);
    };

    const getPayPeriods = async () => {        
        const queryString = initializePayPeriodSearchSettings();
        let result = await get(`/v1.0/AccountsPayable/payperiods${queryString}`);

        if (response.ok) {
            setPayPeriods(result.items.map((pp: PayPeriod) => {
                const insertIndex = pp.periodNumber.toString().length - 2;
                const ppString = insertCharAt(pp.periodNumber.toString(), '-', insertIndex);
                return { id: pp.id, name: ppString, beginDate: pp.beginDate, endDate: pp.endDate };
            }));
        } else {
            console.log('Unable to get pay period data!!!');
        }
    };

    const initializePayPeriodSearchSettings = () => {
        const tableConfig: ITableConfig = {
            rowCount: 500,
            idField: 'Id',
            pageNumber: 1,
            columns: []
        };
        const payPeriodSearchOptions = ODataOptions.from(tableConfig);
        payPeriodSearchOptions.addOrderBy('Id', ODataOrderByDirection.Descending);
        const storedPayperiod = localStorage.getItem('backOfficeSelectedPayPeriod');
        if (!!storedPayperiod && !isNaN(Number(storedPayperiod))) {
            const currentDate = new Date();
            const currentDate2 = new Date();
            const beginDate = new Date(currentDate.setMonth(currentDate.getMonth() - 12)).toLocaleDateString().replace('/', '-').replace('/', '-');
            const endDate = new Date(currentDate2.setMonth(currentDate2.getMonth() + 6)).toLocaleDateString().replace('/', '-').replace('/', '-');
            payPeriodSearchOptions?.addFilter(new ODataFilter('end_date', ODataFilterOperators.LessThan, endDate));
            payPeriodSearchOptions?.addFilter(new ODataFilter('beg_date', ODataFilterOperators.GreaterThan, beginDate));
        } else {
            const months = 3;

            const { beginDate, endDate } = storedPayperiod
              ? getPayPeriodDates(storedPayperiod)
              : (() => {
                  const d = new Date();
                  d.setFullYear(d.getFullYear() - 1);
                  d.setMonth(d.getMonth() + months);
                  return {
                    beginDate: new Date(d.getFullYear(), d.getMonth() - months, d.getDate()),
                    endDate: d
                  };
                })();

            payPeriodSearchOptions?.addFilter(
              new ODataFilter('end_date', ODataFilterOperators.LessThan, endDate.toISOString().split('T')[0])
            );
            payPeriodSearchOptions?.addFilter(
              new ODataFilter('beg_date', ODataFilterOperators.GreaterThan, beginDate.toISOString().split('T')[0])
            );
        }
        
        return payPeriodSearchOptions.toString();
    };

    const getPayPeriodDates = (payPeriod: string): { beginDate: Date; endDate: Date } => {
        const year = parseInt(payPeriod.substring(0, 4), 10);
        const periodNumber = parseInt(payPeriod.substring(4), 10);
        
        // Calculate the month (1-based pay period to 0-based month)
        const month = Math.floor((periodNumber - 1) / 2);
        
        // Get the first day of the month
        const beginDate = new Date(year, month, 1);
        
        // Get the last day of the month
        const endDate = new Date(year, month + 1, 0); // Day 0 of next month = last day of current
        
        return { beginDate, endDate };
    };

    const onDestroy = () => {
        // Put all destruction code here.
    };

    const addNewlyAddedLandmen = () => {
        alert('Implement Add New Landmen');
    };

    const displayOfficeExpenseButtons = () => {
        return (
            <>
                <Button
                    style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                    text={''}
                    title={'Add New Landmen'}
                    reactIcon={BiAddToQueue}
                    iconHoverColor="blue"
                    iconStyle={{width: '2.5rem', height: '2.5rem', verticalAlign: 'center'}}
                    onClick={() => addNewlyAddedLandmen()}
                />
            </>
        );
    };

    const initializeOfficeExpenseSearchSettings = (payPeriod: number) => {
        const tableConfig: ITableConfig = {
            rowCount: 500,
            idField: 'PR_ID',
            pageNumber: 1,
            columns: []
        };
        const billingExpenseSearchOptions = ODataOptions.from(tableConfig);
        billingExpenseSearchOptions.addOrderBy('oe.OF_ID', ODataOrderByDirection.Ascending);
        if (!!payPeriod && payPeriod > 0) {
            billingExpenseSearchOptions?.addFilter(new ODataFilter('oe.[PERIOD_NO]', ODataFilterOperators.Equals, payPeriod));
        }
        
        return billingExpenseSearchOptions.toString();
    };

    const getOfficeTimeEntries = async () => {
        const payPeriod = !!selectedPayPeriod && !isNaN(Number(selectedPayPeriod)) ? selectedPayPeriod : 0;
        const queryString = initializeOfficeExpenseSearchSettings(Number(payPeriod));
        let result = await get(`/v1.0/AccountsPayable/billing/office/expenses${queryString}`);

        if (response.ok) {
            setOfficeTimeEntries(result.items);
        } else {
            console.log('Unable to get office expense data!!!');
        }
    };

    const onSubmit = () => {
        console.log('onSubmit called for save project');
    };

    const setSelectedPayPeriodValue = (value: string) => {
        if (!value) {
            setSelectedPayPeriod(undefined);
            return;
        }
        if (Array.isArray(payPeriods)) {
            const labelValue: PayPeriod = payPeriods.find((pp) =>
                pp.id.toString() === value
            );
            if (!!labelValue?.name) {
                setSelectedPayPeriod(labelValue.name.toString().replace('-', ''));
            }
        }
    };

    const loadData = () => {
        setOfficeTimeEntries([]);
        getOfficeTimeEntries();
    };

    const displayTitle = () => {
        const title = 'Time & Expense Entry';

        return title;
    };

    const displayStaffListSortButtons = () => {
        return (
            <tr className={'project-billing'}>
                <td style={{width: '5%', textAlign: 'center'}}>
                    {!sortDlcNumber && <Button
                        style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                        text={''}
                        title="Sort DLC # Descending"
                        reactIcon={FaSortAlphaDown}
                        iconHoverColor="blue"
                        iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center'}}
                        onClick={() => sortByDlcNumber()}
                    />}
                    {sortDlcNumber && <Button
                        style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                        text={''}
                        title="Sort DLC # Ascending"
                        reactIcon={FaSortAlphaUp}
                        iconHoverColor="blue"
                        iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center'}}
                        onClick={() => sortByDlcNumber()}
                    />}
                </td>
                <td  style={{width: '10%', textAlign: 'center'}}>
                    {!sortName && <Button
                        style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                        text={''}
                        title="Sort Name Descending"
                        reactIcon={FaSortAlphaDown}
                        iconHoverColor="blue"
                        iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center'}}
                        onClick={() => sortByName()}
                    />}
                    {sortName && <Button
                        style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                        text={''}
                        title="Sort Name Ascending"
                        reactIcon={FaSortAlphaUp}
                        iconHoverColor="blue"
                        iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center'}}
                        onClick={() => sortByName()}
                    />}
                </td>
                <td style={{width: '2%', textAlign: 'center'}}>
                    {!sortTkprs && <Button
                        style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                        text={''}
                        title="Sort Tkprs Descending"
                        reactIcon={FaSortAlphaDown}
                        iconHoverColor="blue"
                        iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center'}}
                        onClick={() => sortByTkprs()}
                    />}
                    {sortTkprs && <Button
                        style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                        text={''}
                        title="Sort Tkprs Ascending"
                        reactIcon={FaSortAlphaUp}
                        iconHoverColor="blue"
                        iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center'}}
                        onClick={() => sortByTkprs()}
                    />}
                </td>
                <td style={{width: '2%', textAlign: 'center'}}>
                    {!sortLastDate && <Button
                        style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                        text={''}
                        title="Sort Last Date Descending"
                        reactIcon={FaSortAlphaDown}
                        iconHoverColor="blue"
                        iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center'}}
                        onClick={() => sortByLastDate()}
                    />}
                    {sortLastDate && <Button
                        style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                        text={''}
                        title="Sort Last Date Ascending"
                        reactIcon={FaSortAlphaUp}
                        iconHoverColor="blue"
                        iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center'}}
                        onClick={() => sortByLastDate()}
                    />}
                </td>
                <td style={{width: '2%', textAlign: 'center'}}>
                    {!sortDays && <Button
                        style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                        text={''}
                        title="Sort Days Descending"
                        reactIcon={FaSortAlphaDown}
                        iconHoverColor="blue"
                        iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center'}}
                        onClick={() => sortByDays()}
                    />}
                    {sortDays && <Button
                        style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                        text={''}
                        title="Sort Days Ascending"
                        reactIcon={FaSortAlphaUp}
                        iconHoverColor="blue"
                        iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center'}}
                        onClick={() => sortByDays()}
                    />}
                </td>
                <td style={{width: '2%', textAlign: 'center'}}>
                    {!sortExpenses && <Button
                        style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                        text={''}
                        title="Sort Expenses Descending"
                        reactIcon={FaSortAlphaDown}
                        iconHoverColor="blue"
                        iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center'}}
                        onClick={() => sortByExpenses()}
                    />}
                    {sortExpenses && <Button
                        style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                        text={''}
                        title="Sort Expenses Ascending"
                        reactIcon={FaSortAlphaUp}
                        iconHoverColor="blue"
                        iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center'}}
                        onClick={() => sortByExpenses()}
                    />}
                </td>
                <td style={{width: '2%', textAlign: 'center'}}>
                    {!sortTotal && <Button
                        style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                        text={''}
                        title="Sort Total Descending"
                        reactIcon={FaSortAlphaDown}
                        iconHoverColor="blue"
                        iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center'}}
                        onClick={() => sortByTotal()}
                    />}
                    {sortTotal && <Button
                        style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                        text={''}
                        title="Sort Pay Total Ascending"
                        reactIcon={FaSortAlphaUp}
                        iconHoverColor="blue"
                        iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center'}}
                        onClick={() => sortByTotal()}
                    />}
                </td>
                <td style={{width: '8%', textAlign: 'center'}}>
                    {!sortAprs && <Button
                        style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                        text={''}
                        title="Sort Aprs Descending"
                        reactIcon={FaSortAlphaDown}
                        iconHoverColor="blue"
                        iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center'}}
                        onClick={() => sortByAprs()}
                    />}
                    {sortAprs && <Button
                        style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                        text={''}
                        title="Sort Aprs Ascending"
                        reactIcon={FaSortAlphaUp}
                        iconHoverColor="blue"
                        iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center'}}
                        onClick={() => sortByAprs()}
                    />}
                </td>
                <td style={{width: '8%', textAlign: 'center'}}>
                    {!sortDlcNumber && <Button
                        style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                        text={''}
                        title="Sort DLC # Descending"
                        reactIcon={FaSortAlphaDown}
                        iconHoverColor="blue"
                        iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center'}}
                        onClick={() => sortByDlcNumber()}
                    />}
                    {sortDlcNumber && <Button
                        style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                        text={''}
                        title="Sort DLC # Ascending"
                        reactIcon={FaSortAlphaUp}
                        iconHoverColor="blue"
                        iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center'}}
                        onClick={() => sortByDlcNumber()}
                    />}
                </td>
                <td  style={{width: '8%', textAlign: 'center'}}>
                    {!sortName && <Button
                        style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                        text={''}
                        title="Sort Name Descending"
                        reactIcon={FaSortAlphaDown}
                        iconHoverColor="blue"
                        iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center'}}
                        onClick={() => sortByName()}
                    />}
                    {sortName && <Button
                        style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                        text={''}
                        title="Sort Name Ascending"
                        reactIcon={FaSortAlphaUp}
                        iconHoverColor="blue"
                        iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center'}}
                        onClick={() => sortByName()}
                    />}
                </td>
                <td style={{width: '8%', textAlign: 'center'}}>
                    {!sortTkprs && <Button
                        style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                        text={''}
                        title="Sort Tkprs Descending"
                        reactIcon={FaSortAlphaDown}
                        iconHoverColor="blue"
                        iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center'}}
                        onClick={() => sortByTkprs()}
                    />}
                    {sortTkprs && <Button
                        style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                        text={''}
                        title="Sort Tkprs Ascending"
                        reactIcon={FaSortAlphaUp}
                        iconHoverColor="blue"
                        iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center'}}
                        onClick={() => sortByTkprs()}
                    />}
                </td>
                <td style={{width: '8%', textAlign: 'center'}}>
                    {!sortLastDate && <Button
                        style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                        text={''}
                        title="Sort Last Date Descending"
                        reactIcon={FaSortAlphaDown}
                        iconHoverColor="blue"
                        iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center'}}
                        onClick={() => sortByLastDate()}
                    />}
                    {sortLastDate && <Button
                        style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                        text={''}
                        title="Sort Last Date Ascending"
                        reactIcon={FaSortAlphaUp}
                        iconHoverColor="blue"
                        iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center'}}
                        onClick={() => sortByLastDate()}
                    />}
                </td>
                <td style={{width: '4%', textAlign: 'center'}}>
                    {!sortAprs && <Button
                        style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                        text={''}
                        title="Sort Aprs Descending"
                        reactIcon={FaSortAlphaDown}
                        iconHoverColor="blue"
                        iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center'}}
                        onClick={() => sortByAprs()}
                    />}
                    {sortAprs && <Button
                        style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                        text={''}
                        title="Sort Aprs Ascending"
                        reactIcon={FaSortAlphaUp}
                        iconHoverColor="blue"
                        iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center'}}
                        onClick={() => sortByAprs()}
                    />}
                </td>
                <td style={{width: '4%', textAlign: 'center'}}>
                    {!sortAprs && <Button
                        style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                        text={''}
                        title="Sort Aprs Descending"
                        reactIcon={FaSortAlphaDown}
                        iconHoverColor="blue"
                        iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center'}}
                        onClick={() => sortByAprs()}
                    />}
                    {sortAprs && <Button
                        style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                        text={''}
                        title="Sort Aprs Ascending"
                        reactIcon={FaSortAlphaUp}
                        iconHoverColor="blue"
                        iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center'}}
                        onClick={() => sortByAprs()}
                    />}
                </td>
                <td style={{width: '6%', textAlign: 'center'}}>
                    {!sortDays && <Button
                        style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                        text={''}
                        title="Sort Days Descending"
                        reactIcon={FaSortAlphaDown}
                        iconHoverColor="blue"
                        iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center'}}
                        onClick={() => sortByDays()}
                    />}
                    {sortDays && <Button
                        style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                        text={''}
                        title="Sort Days Ascending"
                        reactIcon={FaSortAlphaUp}
                        iconHoverColor="blue"
                        iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center'}}
                        onClick={() => sortByDays()}
                    />}
                </td>
                <td style={{width: '6%', textAlign: 'center'}}>
                    {!sortExpenses && <Button
                        style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                        text={''}
                        title="Sort Expenses Descending"
                        reactIcon={FaSortAlphaDown}
                        iconHoverColor="blue"
                        iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center'}}
                        onClick={() => sortByExpenses()}
                    />}
                    {sortExpenses && <Button
                        style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                        text={''}
                        title="Sort Expenses Ascending"
                        reactIcon={FaSortAlphaUp}
                        iconHoverColor="blue"
                        iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center'}}
                        onClick={() => sortByExpenses()}
                    />}
                </td>
                <td style={{width: '6%', textAlign: 'center'}}>
                    {!sortTotal && <Button
                        style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                        text={''}
                        title="Sort Total Descending"
                        reactIcon={FaSortAlphaDown}
                        iconHoverColor="blue"
                        iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center'}}
                        onClick={() => sortByTotal()}
                    />}
                    {sortTotal && <Button
                        style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                        text={''}
                        title="Sort Pay Total Ascending"
                        reactIcon={FaSortAlphaUp}
                        iconHoverColor="blue"
                        iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center'}}
                        onClick={() => sortByTotal()}
                    />}
                </td>
            </tr>
        );
    };

    const handleEmailInvoice = (invoiceId: number, payPeriod: string) => {
        alert('Handle email invoice');
    };

    const handleDeleteInvoice = (invoiceId: number) => {
        alert('Handle delete invoice');
    };

    const renderInvoice = () => {
        if (!!data && data.invoiceId) {
          let invoiceId = data?.invoiceId;
          let payPeriod = formData?.name?.replace('-', '');
    
          return (
            <div className="mt-4 p-4 w-full flex flex-col items-center justify-center">
              <p className="ml-2 text-lg font-semibold">
                An Invoice has been attached!
              </p>
              <div className="flex gap-4">
                <div
                  onClick={() => handleEmailInvoice(invoiceId, payPeriod!)}
                  className="bg-green-500 text-white flex justify-center items-center h-[30px] rounded hover:bg-green-700 active:bg-green-300 cursor-pointer"
                >
                  <span className="pl-4">Email Invoice</span>
                  <span className="p-4">
                    <MdEmail />
                  </span>
                </div>
                <div
                  onClick={() => handleDeleteInvoice(invoiceId)}
                  className="bg-red-500 text-white flex justify-center items-center h-[30px] rounded hover:bg-red-700 active:bg-red-300 cursor-pointer"
                >
                  <span className="pl-4">Delete Invoice</span>
                  <span className="p-4">
                    <FiDelete />
                  </span>
                </div>
              </div>
            </div>
          );
        }
        return <div />;
      };

    const dailyCompTimeValues = [
        { label: '0', value: 0 },
        { label: '1/8', value: 0.125 },
        { label: '1/4', value: 0.25 },
        { label: '3/8', value: 0.375 },
        { label: '1/2', value: 0.5 },
        { label: '5/8', value: 0.625 },
        { label: '3/4', value: 0.75 },
        { label: '7/8', value: 0.875 },
        { label: '1', value: 1 },
      ];

    const hasMultipleSameDayEntries = (index: number, calIndex: number) => {
        return false;
    };
    
    const hasBlankWorkDescription = (index: number, calIndex: number) => {
        return false;
    };

    const hasExpenses = (day: CalendarDay) => {
      if (
        day?.dayEntries?.some(
          de => Array.isArray(de.userExpenses) && de.userExpenses.length > 0
        )
      ) {
          return true;
      } else {
        return false;
      }
    };

    const displayStaffList = () => {
        return <div>
            <table style={{border: 'solid 1px #9CA3AF'}} className={'project-billing tw-table'}>
                <thead className={'project-billing tw-thead'}>                    
                    {displayStaffListSortButtons()}
                    <tr className={'project-billing tw-tr'} style={{whiteSpace: 'nowrap', textAlign: 'left', border: 'solid 1px #9CA3AF'}}>
                        <th className={'tw-th'} style={{ width: '5%', textAlign: 'center' }}>Emp #</th>
                        <th style={{ width: '10%', textAlign: 'center' }}>Name</th>
                        <th style={{ width: '2%', textAlign: 'center' }}>Active</th>
                        <th style={{ width: '2%', textAlign: 'center' }}>TkPrs</th>
                        <th style={{ width: '2%', textAlign: 'center' }}>Aprs</th>
                        <th style={{ width: '2%', textAlign: 'center' }}>Aprd</th>
                        <th style={{ width: '2%', textAlign: 'center' }}>NApr</th>
                        <th style={{ width: '8%', textAlign: 'center' }}>Last Date</th>
                        <th style={{ width: '8%', textAlign: 'center' }}>Inv. Date</th>
                        <th style={{ width: '8%', textAlign: 'center' }}>Proof Date</th>
                        <th style={{ width: '8%', textAlign: 'center' }}>File Date</th>
                        <th style={{ width: '8%', textAlign: 'center' }}>Check Date</th>
                        <th style={{ width: '4%', textAlign: 'center' }}>receipts</th>
                        <th style={{ width: '4%', textAlign: 'center' }}>Days</th>
                        <th style={{ width: '6%', textAlign: 'center' }}>Services</th>
                        <th style={{ width: '6%', textAlign: 'center' }}>Expenses</th>
                        <th style={{ width: '6%', textAlign: 'center' }}>Total</th>
                    </tr>
                </thead>
                <div style={{overflowY: 'auto'}}>
                <tbody  className={'project-billing'} style={{overflow: 'hidden'}}>
                    {!loadingTimeEntries && !!timeEntries && timeEntries.length > 0 && timeEntries?.map(
                        (rpc: TimeAndExpenseChecklist, index: number) => {
                        return (
                            <tr key={rpc?.id + index}  className={'project-billing table-item-hover'} style={{ textAlign: 'center' }}>
                                <td style={{ width: '5%' }}>
                                    <RHFInputBox
                                        name={`landmanTsdNumber`}
                                        type="number"
                                        defaultVal={rpc?.employeeNumber?.toString()}
                                        register={registerTimeEntries}
                                        errors={timeEntriesErrors}
                                        style={{ width: '100%' }}
                                        bodyStyle={{ width: '100%' }}
                                    />
                                </td>
                                <td style={{ width: '10%' }}>
                                    <RHFInputBox
                                        name={`employeeName`}
                                        type="text"
                                        defaultVal={rpc?.name}
                                        register={registerTimeEntries}
                                        errors={timeEntriesErrors}
                                        style={{ width: '100%', background: '#d5f7f5' }}
                                        bodyStyle={{ width: '100%' }}
                                    />
                                </td>
                                <td style={{ width: '2%' }}>
                                    <RHFInputBox
                                        name={`active`}
                                        type="text"
                                        defaultVal={!!rpc?.active ? 'Y' : 'N'}
                                        register={registerTimeEntries}
                                        errors={timeEntriesErrors}
                                        style={{ width: '100%' }}
                                        bodyStyle={{ width: '100%' }}
                                    />
                                </td>
                                <td style={{  width: '2%' }}>
                                    <RHFInputBox
                                        name={`tkprs`}
                                        defaultVal={rpc?.turnkeyProspects?.toString()}
                                        style={{ width: '100%'}}
                                        bodyStyle={{ width: '100%'}}
                                        register={registerTimeEntries}
                                        errors={timeEntriesErrors}
                                    />
                                </td>
                                <td style={{ width: '2%' }}>
                                    <RHFInputBox
                                        name={`aprs`}
                                        defaultVal={!!rpc?.approvalCount ? rpc.approvalCount.toString() : '0'}
                                        style={{ width: '100%'}}
                                        bodyStyle={{ width: '100%'}}
                                        register={registerTimeEntries}
                                        errors={timeEntriesErrors}
                                    />
                                </td>
                                <td style={{ width: '2%' }}>
                                    <RHFInputBox
                                        name={`aprd`}
                                        defaultVal={!!rpc?.approvedCount ? rpc.approvedCount.toString() : '0'}
                                        style={{ width: '100%'}}
                                        bodyStyle={{ width: '100%'}}
                                        register={registerTimeEntries}
                                        errors={timeEntriesErrors}
                                    />
                                </td>
                                <td style={{ width: '2%' }}>
                                    <RHFInputBox
                                        name={`napr`}
                                        defaultVal={!!rpc?.approvalsNeeded ? rpc.approvalsNeeded.toString() : '0'}
                                        style={{ width: '100%'}}
                                        bodyStyle={{ width: '100%'}}
                                        register={registerTimeEntries}
                                        errors={timeEntriesErrors}
                                    />
                                </td>
                                <td style={{ width: '8%' }}>
                                    <RHFInputBox
                                        name={`lastDate`}
                                        defaultVal={!!rpc?.lastDate && rpc.lastDate instanceof Date ?
                                            rpc.lastDate.toLocaleDateString() : new Date(!!rpc.lastDate ? rpc.lastDate : '').toLocaleDateString()}
                                        style={{ width: '100%'}}
                                        bodyStyle={{ width: '100%'}}
                                        register={registerTimeEntries}
                                        errors={timeEntriesErrors}
                                    />
                                </td>
                                <td style={{ width: '8%' }}>
                                    <RHFInputBox
                                        name={`invoiceDate`}
                                        defaultVal={!!rpc?.invoiceDate && rpc.lastDate instanceof Date ?
                                            rpc.invoiceDate.toLocaleDateString() : new Date(!!rpc.invoiceDate ? rpc.invoiceDate : '').toLocaleDateString()}
                                        style={{ width: '100%'}}
                                        bodyStyle={{ width: '100%'}}
                                        register={registerTimeEntries}
                                        errors={timeEntriesErrors}
                                    />
                                </td>
                                <td style={{ width: '8%' }}>
                                    <RHFInputBox
                                        name={`proofDate`}
                                        defaultVal={!!rpc?.proofDate && rpc.proofDate instanceof Date ?
                                            rpc.proofDate.toLocaleDateString() : new Date(!!rpc.proofDate ? rpc.proofDate : '').toLocaleDateString()}
                                        style={{ width: '100%'}}
                                        bodyStyle={{ width: '100%'}}
                                        register={registerTimeEntries}
                                        errors={timeEntriesErrors}
                                    />
                                </td>
                                <td style={{ width: '8%' }}>
                                    <RHFInputBox
                                        name={`tsFileDate`}
                                        defaultVal={!!rpc?.fileDate && rpc.fileDate instanceof Date ?
                                            rpc.fileDate.toLocaleDateString() : new Date(!!rpc.fileDate ? rpc.fileDate : '').toLocaleDateString()}
                                        style={{ width: '100%'}}
                                        bodyStyle={{ width: '100%'}}
                                        register={registerTimeEntries}
                                        errors={timeEntriesErrors}
                                    />
                                </td>
                                <td style={{ width: '8%' }}>
                                    <RHFInputBox
                                        name={`checkDate`}
                                        defaultVal={!!rpc?.checkDate && rpc.checkDate instanceof Date ?
                                            rpc.checkDate.toLocaleDateString() : new Date(!!rpc.checkDate ? rpc.checkDate : '').toLocaleDateString()}
                                        style={{ width: '100%'}}
                                        bodyStyle={{ width: '100%'}}
                                        register={registerTimeEntries}
                                        errors={timeEntriesErrors}
                                    />
                                </td>
                                <td style={{ width: '4%' }}>
                                    <RHFInputBox
                                        name={`receipts`}
                                        defaultVal={!!rpc?.receipts ? rpc.receipts.toString() : '0'}
                                        style={{ width: '100%'}}
                                        bodyStyle={{ width: '100%'}}
                                        register={registerTimeEntries}
                                        errors={timeEntriesErrors}
                                    />
                                </td>
                                <td style={{ width: '4%' }}>
                                    <RHFInputBox
                                        name={`days`}
                                        type="number"
                                        defaultVal={rpc?.days?.toString()}
                                        register={registerTimeEntries}
                                        errors={timeEntriesErrors}
                                        style={{ width: '100%' }}
                                        bodyStyle={{ width: '100%' }}
                                    />
                                </td>
                                <td style={{ width: '6%' }}>
                                    <RHFInputBox
                                        name={`services`}
                                        defaultVal={!!rpc?.services ? rpc.services.toString() : '0'}
                                        style={{ width: '100%'}}
                                        bodyStyle={{ width: '100%'}}
                                        register={registerTimeEntries}
                                        errors={timeEntriesErrors}
                                    />
                                </td>
                                <td style={{ width: '6%' }}>
                                    <RHFInputBox
                                        name={`expenses`}
                                        defaultVal={!!rpc?.expenses ? rpc.expenses.toString() : '0'}
                                        style={{ width: '100%'}}
                                        bodyStyle={{ width: '100%'}}
                                        register={registerTimeEntries}
                                        errors={timeEntriesErrors}
                                        onChange={(e) => handleExpensesChanged(index, e.currentTarget.value)}
                                    />
                                </td>
                                <td style={{ width: '6%' }}>
                                    <RHFInputBox
                                        name={`totalAmount`}
                                        defaultVal={!!rpc?.total ? rpc.total.toString() : '0'}
                                        style={{ width: '100%'}}
                                        bodyStyle={{ width: '100%'}}
                                        register={registerTimeEntries}
                                        errors={timeEntriesErrors}
                                        onChange={(e) => handleTotalAmountChanged(index, e.currentTarget.value)}
                                    />
                                </td>
                            </tr>
                        );
                    })}
                </tbody>
                </div>
            </table>
        </div>;
    };

    const extractNumber = (hoursString: string) => {
      const match = hoursString.match(/^day(\d+)Hours$/);
      return match ? Number(match[1]) : null;
    };    

    const extractDayEntryValues = (fieldSummary: BillingSummary[]) => {
      const mappedFields = new Array<Array<{ key: string, value: number | null}>>();
      fieldSummary.forEach((obj, index) => {
        mappedFields[index] = new Array<{ key: string, value: number | null}>();
        Object.keys(obj).forEach((prop) => {
          const dayValue = billingSummary[index][prop as unknown as keyof BillingSummary];
          mappedFields[index].push({ key: (prop as string), value: dayValue as number | null });
        });
      });
      return mappedFields;
    };

    const findWorkDescriptionByTmId = (
      tmId: number
    ): { wd: string, dt: string } | undefined => {
      for (const day of calendarDays) {
        for (const entry of day.dayEntries) {
          if (entry.tmId === tmId) {
            return { wd: entry.workDescription, dt: entry.tmDate };
          }
        }
      }
      return undefined; // return undefined if no match
    };

    const editOrCreateTimeEntry = (tmId: number | null, summaryItem: BillingSummary, newTimeEntryValue: number, dateOfEntry: string = null) => {
      const compType = (timeExpenseData as { compensationTypeForPayPeriod: string })?.compensationTypeForPayPeriod;

      const payload = new EditDayEntry();
      payload.clientNumber = !isNaN(Number(summaryItem.clientNumber)) ? Number(summaryItem.clientNumber) : null;
      payload.prospectNumber = !isNaN(Number(summaryItem.prospectNumber)) ? Number(summaryItem.prospectNumber) : null;
      payload.sectionNumber = !isNaN(Number(summaryItem.sectionNumber)) ? Number(summaryItem.sectionNumber) : null;
      payload.unitNumber = !isNaN(Number(summaryItem.unitNumber)) ? Number(summaryItem.unitNumber) : null;
      payload.compensationType = compType;
      payload.hours = typeof newTimeEntryValue === 'string' && (newTimeEntryValue as string) === '' ? null : newTimeEntryValue;
      payload.tsdNo = !!delegatedDlcNumber ? delegatedDlcNumber.toString() : dlcNumber.toString();
      payload.periodNo = selectedPayPeriod;
      payload.tmDate = new Date().toLocaleDateString();
      payload.accountNumber = !isNaN(Number(summaryItem.workClassificationName)) ? Number(summaryItem.workClassificationName) : null;
      payload.userExpenses = [];
      payload.workDescription = '';

      // Todo: if payload.hours === null, deleteDayEntry
      if (!!tmId && !isNaN(tmId)) {
        payload.workDescription = findWorkDescriptionByTmId(tmId).wd;
        payload.tmDate = findWorkDescriptionByTmId(tmId).dt;
        payload.tmId = tmId;
        if (payload.hours === null || payload.hours === undefined) {
          deleteDayEntry(tmId);
        } else {
          editDayEntry(payload);
        }
      } else {
        payload.tmDate = dateOfEntry;
        createDayEntry(payload as unknown as PDEResquestType);
      }
    };

    const addRowToTimesheet = () => {
      const newBillingSummary = new BillingSummary();
      const newSummary = _.cloneDeep(billingSummary);
      newSummary.push(newBillingSummary);
      setBillingSummary(newSummary);
    };
    
    const handleSaveAll = () => {
      if (isDirty) {
        const updatedSummary = getValues().summary;
        const mappedFields = extractDayEntryValues(dirtyFields.summary);
        console.log(!!mappedFields && mappedFields.length > 0);
        dirtyFields.summary.forEach((elem: { value: boolean }, index: number) => { 
          let dayIndex = 0;   
          for (let day in elem) {
            if (Object.prototype.hasOwnProperty.call(elem, day)) {
              const tmidIndex = extractNumber(day);
              const existingTmid = Array.isArray(billingSummary) && billingSummary.length > index &&
                Array.isArray(billingSummary[index].tmIds) && billingSummary[index].tmIds.length > tmidIndex - 1 ? billingSummary[index].tmIds[tmidIndex - 1] : null;
              const newHourValue = updatedSummary[index][day];
              const previousHourValue = mappedFields[index][dayIndex++].value;
              if ((existingTmid !== null && existingTmid !== undefined) && !isNaN(Number(newHourValue)) && !isNaN(Number(previousHourValue))) {
                // edit this time entry with the new hour value
                console.log(existingTmid); // should have a valid tmId
                console.log(newHourValue); // should be the newly entered value
                console.log(previousHourValue); // should also be a valid previous value
                editOrCreateTimeEntry(existingTmid, billingSummary[index], newHourValue);
              } else if ((existingTmid === null || existingTmid === undefined) && (!isNaN(Number(newHourValue)) && newHourValue !== '') && (previousHourValue === null || typeof previousHourValue === 'number')) {
                // this is a new time entry so create a new one
                console.log(existingTmid);   // should be null
                console.log(newHourValue); // should be the newly entered value
                console.log(previousHourValue);   // should be null
                const dateOfEntry = new Date(calendarDays[tmidIndex - 1].dateTime).toLocaleDateString();
                editOrCreateTimeEntry(existingTmid, billingSummary[index], newHourValue, dateOfEntry);
              }
              // Iterate through all of the dirty fields
              // if tmids[index] for day[index + 1]Hours is not null, update that tmId with the value in dirtyFields
              // if tmids[index] is null, create a new time entry with the value from dirtyFields 
              console.log(day + index);
            }
          }
        });
      }
    };

    const handleAddRow = () => {
      addRowToTimesheet();
    };

    const handleApproveTimesheet = () => {
      if (!timeExpenseToken) {
        getTimeAndExpenseToken();
      } else {
        const payPeriod = 202517;
        const tsdNumber = 204;
        const proofedBy = 'CRESTON PERKINS';
        approveTimesheet(payPeriod, tsdNumber, proofedBy);
      }
    };

    const handleResetTimesheet = () => {
      dispatch(actions.layout.showDialog(DialogList.FLAG_REASON_DIALOG));
    };

    const handleOpenInvoice = () => {
        alert('implement handle email by day');
    };

    const handleEmailByDay = () => {
        alert('implement handle email by day');
    };

    const handleEmailByProspect = () => {
        alert('implement handle email by prospect');
    };

    const handlePayPeriodNav = () => {
        const formValues = getSearchOptionsValues();
        let tsdiNumber = !!formValues?.dlcNumber ? formValues?.dlcNumber : (!!dlcNumber && !isNaN(Number(dlcNumber)) ? Number(dlcNumber) : 0);

        if (!tsdiNumber) {
          const decodedJwt =  decodeJwtPayload(timeExpenseToken);
          tsdiNumber = decodedJwt.tn;
        }

        getTimeSheetForOtherUser(formValues.payPeriod, tsdiNumber);
        const payPeriod = formValues.payPeriod.replace('-', '');
        if (payPeriod) {
          setSelectedPayPeriod(payPeriod);
          getTimePeriodCutoffDate(payPeriod, dlcNumber).then((result) => {
            setPeriodCutoffDate(result as Date);
          });
        }
    };

    const handleAdminUserNav = () => {
      const formValues = getSearchOptionsValues();
      let tsdiNumber = !!formValues?.dlcNumber && !isNaN(Number(formValues.dlcNumber)) ? Number(formValues.dlcNumber) :
        (!!delegatedDlcNumber && !isNaN(Number(delegatedDlcNumber)) ? Number(delegatedDlcNumber) : 0);

      if (!tsdiNumber) {
        const decodedJwt =  decodeJwtPayload(timeExpenseToken);
        tsdiNumber = !isNaN(Number(decodedJwt.tn)) ? Number(decodedJwt.tn) : 0;
      } else {
        setDelegatedDlcNumber(tsdiNumber);
      }

      const currentPayPeriod = formValues.payPeriod.replace('-', '');

      getTimeSheetForOtherUser(formValues.payPeriod, tsdiNumber);
      setSelectedPayPeriod(currentPayPeriod);
      getTimePeriodCutoffDate(currentPayPeriod, dlcNumber).then((result) => {
        setPeriodCutoffDate(result as Date);
      });
    };

    const handleProspectNumberChange = async (e: FormEvent) => {
      const formValues = getValues();
      const clientNumber = Number(formValues?.summary[selectedIndex]?.clientNumber);
      const projectNumber = Number( formValues?.summary[selectedIndex]?.prospectNumber);
      const result = await validateBillingCode(clientNumber, projectNumber, '0', '0');
      console.log(result);
    };

    const handleClientNumberChange = (e: FormEvent) => {
       // alert('implement handle client nav');
       // noop. I don't think we need to do anything yet
    };

    const handleTimeValueChange = (calIndex: number, index: number, e: FormEvent) => {
      const target = e.target as HTMLInputElement;
      // setValue(target.name, target.value);
      // alert('target ' + target.name + ' set to ' + target.value);
      updateHoursFromInput(target.name, Number(target.value));
    };

    const handleSectionNumberChange = (e: FormEvent) => {
      alert('implement handle section nav');
    };

    const handleUnitNumberChange = (e: FormEvent) => {
        alert('implement handle unit nav');
    };

    const updateHoursFromInput = (inputName: string, newValue: number | null) => {
      // Parse row index and day key from input name
      // Example: 'summary.0.day5Hours'
      const match = inputName.match(/^summary\.(\d+)\.(day\d+Hours)$/);
      if (!match) {
        return;
      }
    
      const rowIndex = parseInt(match[1], 10);
      const potentialKey = match[2] as keyof BillingSummary;
    
      const row = billingSummary[rowIndex];
      if (!row) {
        return;
      }
    
      // Runtime check to ensure the key is a valid day field
      if (!/^day\d+Hours$/.test(potentialKey)) {
        return;
      }
    
      // Cast is safe now because of the runtime check
      const dayKey = potentialKey as
        | 'day1Hours'
        | 'day2Hours'
        | 'day3Hours'
        | 'day4Hours'
        | 'day5Hours'
        | 'day6Hours'
        | 'day7Hours'
        | 'day8Hours'
        | 'day9Hours'
        | 'day10Hours'
        | 'day11Hours'
        | 'day12Hours'
        | 'day13Hours'
        | 'day14Hours'
        | 'day15Hours'
        | 'day16Hours';
    
      row[dayKey] = newValue;
    
      // Update row total
      let rowTotal = 0;
      for (let i = 1; i <= 16; i++) {
        const key = `day${i}Hours` as keyof BillingSummary;
        const val = row[key];
        if (typeof val === 'number') {
          rowTotal += val;
        }
      }
      row.totalHours = rowTotal;
      setValue(`summary.${rowIndex}.totalHours`, rowTotal);
    
      // Update column total
      let dayColumnTotal = 0;
      for (const r of billingSummary) {
        const val = r[dayKey];
        if (typeof val === 'number') {
          dayColumnTotal += val;
        }
      }
      setValue(`${dayKey.replace('Hours', 'TotalHours')}`, dayColumnTotal);
    
      // Update overall total
      let overallTotal = 0;
      for (const r of billingSummary) {
        if (typeof r.totalHours === 'number') {
          overallTotal += r.totalHours;
        }
      }
      setValue('totalHours', overallTotal);
    };

    const onChangeActivityType = (index: number, value: string) => {
        setUnsavedChanges(true);
        const name = `summary.${index}.workClassificationName`;
        setValue(name, value);
    };

    const handleUpdate = (index: number) => {
        console.log('update what?');
    };

    const hideWarningDialog = () => {
      hideDialog();
      handlePayPeriodNav();
      setShowWorkExpenseDialog(new Object());
    };

    const showWorkDescriptionAndExpenseDialog = () => {
      showDialog(DialogList.EDIT_TIME_AND_EXPENSE);
    };

    const showDeleteWarningDialog = () => {
      showDialog(DialogList.CONFIRM_DELETE_TIME_ENTRY);
    };

    const isDelegatedDlcNumber = (compareDlcNumber: number) => {
      const returnValue = compareDlcNumber === dlcNumber;
      return returnValue;
    };

    const hideDialog = () => {
        dispatch(actions.layout.hideDialog());
    };

    const hideReceiptViewerDialog = () => {
      hideDialog();
      showWorkDescriptionAndExpenseDialog();
    };

    const handleConfirmDeleteTimeEntry = () => {
      hideWarningDialog();
      setConfirmDeleteDayEntry(true);
    };

    const getTsdiAccountNameFromCode = (code: number) => {
      if (!code) {
        return null;
      }
      return tsdiAccounts.find((acct) => acct.code === code )?.description;
    };

    const handleSetReasonForTimesheetReset = (reason: string, type: number) => {
      alert('Reset time sheet: ' + reason + `:${type}`);
    };

    const getBillingCode = () => {
      const billingCode =  !!billingSummary && billingSummary.length > selectedIndex ?
      { clientNumber: billingSummary[selectedIndex].clientNumber,
        prospectNumber: billingSummary[selectedIndex].prospectNumber,
        sectionNumber: billingSummary[selectedIndex]?.sectionNumber ? billingSummary[selectedIndex].sectionNumber : 0,
        unitNumber: (billingSummary[selectedIndex]?.unitNumber ? billingSummary[selectedIndex].unitNumber : 0),
        activityType: getTsdiAccountNameFromCode(Number(billingSummary[selectedIndex].workClassificationName))} : new BillingCode();
      return billingCode;
    };

    const getOfficeExpenseReceiptsThumbnails = async () => {
      if (!!prototypeOfficeExpenseId) {
          let result = await get(`/v1.0/AccountsPayable/receipts/expense/${prototypeOfficeExpenseId}/receipts/thumbnails`);

          if (response.ok && result?.length > 0) {
              setReceiptThumbnails(result);
          } else {
              console.log('Unable to get office expense receipt thumbnail data!!!');
          }
      }
    };

    const displayTimeSheet = () => {
        return (
            <>
              <a style={{ display: 'hidden' }} id="timesheetReport" />
              { unsavedChanges &&
              <div
                className={`tw-w-[100%] tw-border tw-border-orange-300 tw-border-t-[1px] tw-rounded tw-border-l-[1px]`}
                style={{color: 'darkred', fontSize: '20px', position: 'fixed', zIndex: 1000, height: '30px', width: '100%', background: '#fdef64', textAlign: 'center'}}
              >
                Complete entry to save your changes!
              </div>}
              {!loadingPage && (
                <div style={{backgroundColor: 'white', padding: '0px', margin: '0'}} className="tw-flex tw-items-center tw-justify-center tw-p-[24px_8px_16px_8px] sm:tw-px-6 lg:tw-px-8">
                  <div className="tw-flex tw-flex-col tw-w-full">
                    <div className="tw-text-center">
                      {!!payPeriodValidation || !!hasInvoice ? (
                        <h1 className="tw-text-[2rem] tw-font-semibold tw-mb-4 tw-underline tw-text-red-400">
                          {'This Pay Period is ' + (!!payPeriodLocked ? 'Locked!' : 'Closed!')}
                        </h1>
                      ) : <></>}
                    </div>
                    <div className="tw-flex tw-flex-col tw-gap-2 tw-items-center tw-justify-center tw-mb-8">
                      <p className="tw-text-black tw-text-lg tw-font-medium">
                        {`\u21D8To have your timesheet emailed to you, choose to format by day or by prospect\u21D9`}
                      </p>
                      <div className="tw-flex tw-gap-4">
                        <div
                          className="tw-bg-gray-500 tw-text-white tw-flex tw-justify-center tw-items-center tw-h-[30px] tw-rounded hover:tw-bg-gray-700 active:tw-bg-gray-300 tw-cursor-pointer"
                          onClick={() => handleEmailByDay()}
                        >
                          <span className="tw-p-4">
                            <MdEmail />
                          </span>
                          <span className="tw-pr-4">By Day</span>
                        </div>
                        <div
                          className="tw-bg-gray-500 tw-text-white tw-flex tw-justify-center tw-items-center tw-h-[30px] tw-rounded hover:tw-bg-gray-700 active:tw-bg-gray-300 tw-cursor-pointer"
                          onClick={() => handleEmailByProspect()}
                        >
                          <span className="tw-p-4">
                            <MdEmail />
                          </span>
                          <span className="tw-pr-4">By Prospect</span>
                        </div>
                      </div>
                    </div>
                    <form onSubmit={handleSubmit(onSubmit)}>
                      <div className="tw-flex tw-gap-4 tw-justify-center tw-items-end tw-mb-8">
                        {!!userRole && (userRole === 'ad' || userRole === 'al') && (
                          <div className="tw-flex tw-flex-col tw-justify-center tw-items-start">
                            <div>
                              <label style={{margin: '0px'}} className="tw-text-black tw-font-medium tw-text-lg">
                                {' ' }
                                Name:{' '}
                                <span className="tw-text-gray-500">
                                  {!!appContext?.currentUser?.username ? appContext.currentUser.username : ''}
                                </span>
                              </label>
                            </div>
                            <div>
                              <p className="tw-text-black tw-font-medium tw-text-lg">
                                DLC #:{' '}
                                <span className="tw-text-gray-500">
                                  {!!dlcNumber ? `${dlcNumber}` : ''}
                                </span>
                              </p>
                            </div>        
                            <div className="tw-flex tw-justify-center tw-items-center tw-border tw-border-gray-300 tw-p-[2px_0px]">
                              <span className="tw-text-lg tw-ml-2 tw-mr-1">#</span>
                              <RHFInputBox
                                register={registerSearchOptions}
                                placeholder="Enter DLC #"
                                name="dlcNumber"
                                bodyStyle={{marginRight: '0px'}}
                              />
                              { (!!delegatedDlcNumber && !isDelegatedDlcNumber(delegatedDlcNumber)) &&  <span className="tw-text-lg tw-text-red-500">(D)</span>}
                            </div>
                          </div>
                        )}
                        <div
                          className={
                            !!userRole && (userRole === 'ad' || userRole === 'al')
                              ? 'tw-flex tw-flex-col tw-justify-center tw-items-start tw-gap-2'
                              : 'tw-flex tw-justify-center tw-items-center tw-gap-4'
                          }
                        >
                          <label
                            htmlFor="payPeriod"
                            className="tw-text-lg tw-text-gray-500 tw-font-medium"
                          >
                            Pay Period
                          </label>
                          <div className="tw-flex tw-items-center tw-justify-center tw-gap-4">
                            <div className="tw-flex tw-justify-center tw-items-center tw-border tw-border-gray-300 tw-p-[2px_0px]">
                              <RHFInputBox
                                register={registerSearchOptions}
                                name={'payPeriod'}
                              />
                            </div>
                            {!!userRole && userRole !== 'ad' && userRole !== 'al' && (
                              <div
                                className="tw-bg-gray-500 text-white tw-p-[5px_13px_5px_13px] tw-hover:bg-gray-600 tw-active:bg-gray-400"
                                onClick={() => handlePayPeriodNav()}
                              >
                                <RefreshIcon size={10} strokeWidth={2} />
                                {/*<MdRefresh className="text-2xl cursor-pointer" />*/}
                              </div>
                            )}
                            {!!userRole && (userRole === 'ad' || userRole === 'al') && (
                              <div
                                className="tw-bg-gray-500 tw-text-white tw-p-[5px_13px_5px_13px] tw-hover:tw-bg-gray-600 tw-active:tw-bg-gray-400"
                                onClick={() => handleAdminUserNav()}
                              >
                                <RefreshIcon size={24} strokeWidth={4} />
                                {/*<MdRefresh className="tw-text-2xl tw-cursor-pointer" />*/}
                              </div>
                            )}
                            <label style={{whiteSpace: 'nowrap'}}>
                                Cutoff date:
                            </label>
                            <label>
                                {!!periodCutoffDate ? new Date(periodCutoffDate).toLocaleDateString() : ''}
                            </label>
                          </div>
                        </div>
                      </div>
        
                      <table className={'project-billing project-billing-te tw-table tw-w-full tw-border tw-border-gray-400 tw-border-collapse'}>
                        <thead className={'project-billing tw-thead'}>
                          <tr style={{border: 'solid 1px #9CA3AF'}} className={'project-billing tw-tr'}>
                            <th style={{padding: '8px'}} className="tw-th tw-border tw-border-gray-400 tw-px-4 tw-py-2">
                              Client #
                            </th>
                            <th style={{padding: '5px'}} className="tw-border tw-border-gray-400 tw-px-4 tw-py-2">
                              Project #
                            </th>
                            <th style={{padding: '5px'}} className="tw-border tw-border-gray-400 tw-px-4 tw-py-2">
                              Section #
                            </th>
                            <th className="tw-border tw-border-gray-400 tw-px-4 tw-py-2">
                              Unit #
                            </th>
                            <th style={{width: '150px'}} className="tw-border tw-border-gray-400 tw-px-4 tw-py-2">
                              Activity Type
                            </th>
                            {!!calendarDays &&
                              calendarDays.map((cd, index) => {
                                let classNames = 'tw-border tw-border-gray-400 tw-px-4 tw-py-2';
                                if (cd.dayType === 2) {
                                  classNames += ' tw-bg-amber-200';
                                } else if (cd.dayType === 1) {
                                    classNames += ' tw-bg-gray-200';
                                }
                                return (
                                  <th
                                    key={index}
                                    className={classNames}
                                  >
                                    {cd.dayName}<br />{`${cd.friendlyDate}`}
                                  </th>
                                );
                              })}
                            {compensationType === 'H' && <th className="tw-border tw-border-gray-400 tw-px-4 tw-py-2">
                               Total Hours                      
                            </th>}
                            {compensationType === 'D' && <th className="tw-border tw-border-gray-400 tw-px-4 tw-py-2">
                               Total Days                      
                            </th>}
                            <th className="tw-border tw-border-gray-400 tw-px-4 tw-py-2">
                              Edit
                            </th>
                          </tr>
                        </thead>
                        <tbody
                          className={
                            !!(payPeriodValidation || hasInvoice)
                              ? 'tw-bg-gray-400 tw-cursor-not-allowed'
                              : ''
                          }
                        >
                          {!!billingSummary && billingSummary?.map((s, index) => (
                            <tr className={'project-billing'} key={index} onClick={() => setSelectedIndex(index)}>
                              <td hidden={true}>
                                <input
                                  type="checkbox"
                                  defaultChecked={false}
                                />
                              </td>
                              <td className="tw-border tw-border-gray-400 ">
                                <RHFInputBox
                                  id={`client-debounce[${index}]`}
                                  register={register}
                                  className="tw-w-full tw-h-full tw-border tw-border-gray-300 tw-px-2 tw-py-1 tw-text-center"
                                  name={`summary.${index}.clientNumber`}
                                  onChange={(e) => handleClientNumberChange(e)}
                                  disabled={payPeriodValidation || hasInvoice}
                                />
                              </td>
                              <td className="tw-border tw-border-gray-400 ">
                                <RHFInputBox
                                  id={`project-debounce[${index}]`}
                                  register={register}
                                  className="tw-w-full tw-h-full tw-border tw-border-gray-300 tw-px-2 tw-py-1 tw-text-center"
                                  name={`summary.${index}.prospectNumber`}
                                  onChange={(e) => handleProspectNumberChange(e)}
                                  disabled={payPeriodValidation || hasInvoice}
                                />
                              </td>
                              <td className="tw-border tw-border-gray-400 ">
                                <RHFInputBox
                                  register={register}
                                  className={`tw-w-full tw-h-full tw-border tw-border-gray-300 tw-px-2 tw-py-1 ${
                                    !!showError[index] && showError[index][997]?.calIndex === 997 &&
                                    !!showError[index][997]?.invalid
                                      ? 'tw-bg-red-200'
                                      : ''
                                  }`}
                                  style={{padding: '5px'}}
                                  name={`summary.${index}.sectionNumber`}
                                  onChange={(e) => handleSectionNumberChange(e)}
                                  disabled={payPeriodValidation || hasInvoice}
                                />
                              </td>
                              <td className="tw-border tw-border-gray-400 ">
                                <RHFInputBox
                                  register={register}
                                  className={`tw-w-full tw-h-full tw-border tw-border-gray-300 tw-px-2 tw-py-1 ${
                                    !!showError[index] && showError[index][998]?.calIndex === 998 &&
                                    !!showError[index][998]?.invalid
                                      ? 'tw-bg-red-200'
                                      : ''
                                  }`}
                                  name={`summary.${index}.unitNumber`}
                                  onChange={(e) => handleUnitNumberChange(e)}
                                  disabled={!selectedPayPeriod || hasInvoice}
                                />
                              </td>
                              <td style={{width: '150px'}} className="tw-border tw-border-gray-400 ">
                                <RHFSelect
                                  register={register}
                                  id="workType"
                                  name={`summary.${index}.workClassificationName`}
                                  className={`tw-w-full tw-h-full tw-border tw-border-gray-300 tw-px-2 tw-py-1 ${
                                    !!showError[index] && showError[index][999]?.calIndex === 999 &&
                                    !!showError[index][999]?.invalid
                                      ? 'tw-bg-red-200'
                                      : ''
                                  }`}
                                  style={{width: '100%'}}
                                  bodyStyle={{width: '100%'}} 
                                  options={!!tsdiAccounts ? tsdiAccounts?.map(ta => { return { value: ta.code, label: ta.description }; }) : [{ value: 1, label: 'no accounts'}]}
                                  disabled={!selectedPayPeriod}
                                  onChange={(e: FormEvent<HTMLSelectElement>) => e !== undefined ? onChangeActivityType(index, e.currentTarget.value) : false}
                                  // rules={{
                                  //   onBlur(event) {
                                  //     validateInput(
                                  //       "workType",
                                  //       event.target.value,
                                  //       999,
                                  //       index
                                  //     );
                                  //   },
                                  // }}
                                />
                              </td>
        
                              {calendarDays.map((cd, calIndex) => {
                                const yellowHighlight = hasMultipleSameDayEntries(index, calIndex);
                                const purpleHighlight = hasBlankWorkDescription(index, calIndex);
                                const orangeHighlight = hasExpenses(cd);
/*                                 let classNameString = `w-full h-full border border-gray-300 py-1 text-center`;
                                if (index === 3 && calIndex === 0) {
                                  classNameString += 'bg-yellow-200';
                                } */
        
                                return (
                                  <td
                                    className="tw-border tw-border-gray-400 "
                                    key={`Summary ${index}-Day ${calIndex}`}
                                  >
                                    {!!compensationType && compensationType === 'H' && (
                                      <RHFInputBox
                                        onChange={(e) => e !== undefined ? handleTimeValueChange(calIndex, index, e) : false}
                                        register={register}
                                        className={`tw-w-full tw-h-full tw-border tw-border-gray-300 tw-py-1 tw-text-center ${
                                            !!showError[index] && showError[index][calIndex]?.calIndex ===
                                            calIndex &&
                                          !!showError[index][calIndex]?.invalid
                                            ? 'tw-bg-red-200'
                                            : (orangeHighlight)
                                            ? 'tw-bg-orange-200'
                                            : (purpleHighlight || yellowHighlight)
                                            ? (purpleHighlight === true ? 'tw-bg-purple-200' : 'tw-bg-yellow-200')
                                            : cd?.dayType === 2
                                            ? 'tw-bg-amber-200'
                                            : cd?.dayType === 1
                                            ? 'tw-bg-gray-200'
                                            : ''
                                        }`}
                                        placeholder="hourly"
                                        name={`summary.${index}.day${
                                          calIndex + 1
                                        }Hours`}
                                        disabled={
                                          (!selectedProject &&
                                          payPeriodValidation)
                                          /* || (validProspect?.data?.isSectionRequired && !sectionNumberReady) || 
                                          (validProspect?.data?.isUnitRequired && !unitNumberReady)*/ 
                                        }
                                      />
                                    )}
        
                                    {!!compensationType && compensationType === 'D' && (
                                      <RHFSelect
                                        onChange={(e: FormEvent) => handleTimeValueChange(calIndex, index, e)}
                                        register={register}
                                        name={`summary.${index}.day${
                                          calIndex + 1
                                        }Hours`}
                                        options={dailyCompTimeValues?.map((dt) => {
                                          return { value: dt?.value, label: dt?.label };
                                        })}
                                        disabled={
                                          (!selectedProject &&
                                          payPeriodValidation)
                                          /* || (validProspect?.data?.isSectionRequired && !sectionNumberReady) || 
                                          (validProspect?.data?.isUnitRequired && !unitNumberReady)*/
                                        }
                                      />
                                    )}
                                  </td>
                                );
                              })}
        
                              <td
                                className="tw-border tw-border-gray-400 tw-bg-gray-400"
                                key={`Summary ${index}-TotalHours`}
                              >
                                <RHFInputBox
                                  register={register}
                                  className="tw-w-full tw-h-full tw-border tw-border-gray-300 tw-px-2 tw-py-1 tw-text-center"
                                  name={`summary.${index}.totalHours`}
                                  disabled={true}
                                />
                              </td>
                              <td
                                onClick={() => handleUpdate(index)}
                                className="tw-border tw-border-gray-400 tw-text-center tw-cursor-pointer"
                              >
                                {!!payPeriodValidation || !!hasInvoice ? (
                                  <span>View</span>
                                ) : (
                                <Button
                                    type={'button'}
                                    style={{ height: '3rem', marginLeft: '1rem', background: 'transparent', padding: '.5px 0px 0.5px 0px'}}
                                    text={''}
                                    title="Edit Work Description & Expenses"
                                    reactIcon={FaPenSquare}
                                    iconHoverColor="blue"
                                    iconStyle={{width: '3rem', height: '3rem', verticalAlign: 'center'}}
                                    onClick={() => setShowWorkExpenseDialog(new Object())}
                                />
                                )}
                              </td>
                            </tr>
                          ))}
                          <tr className={'project-billing'} key={'Summary Totals'}>
                            <td colSpan={4} className={'center-cell'}>
                              <button
                                className="tw-bg-green-500 tw-text-white tw-py-2 tw-px-4 tw-hover:bg-green-600"
                                onClick={handleAddRow}
                                type="button"
                              >
                                Add Row
                              </button>
                            </td>
                            <td style={{width: '150PX'}} className="tw-border tw-border-gray-400 tw-bg-gray-400 tw-text-center">
                              <span>TOTAL</span>
                            </td>
                            {calendarDays && Array.isArray(calendarDays) && calendarDays?.map((cd, calIndex) => {
                              return (
                                <td
                                  className="tw-border tw-border-gray-400 tw-bg-gray-400"
                                  key={`Day ${calIndex}-Total Hours`}
                                >
                                  <RHFInputBox
                                    disabled={true}
                                    register={register}
                                    className="tw-w-full tw-h-full tw-border tw-border-gray-300 tw-px-2 tw-py-1 tw-text-center"
                                    defaultVal={''}
                                    name={`day${calIndex + 1}TotalHours`}
                                  />
                                </td>
                              );
                            })}
                            <td
                              className="tw-border tw-border-gray-400 tw-bg-gray-400"
                              key={`TotalHours`}
                            >
                              <RHFInputBox
                                disabled={true}
                                register={register}
                                className="tw-w-full tw-h-full tw-border tw-border-gray-300 tw-px-2 tw-py-1 tw-text-center"
                                name={`totalHours`}
                                defaultVal={''}
                              />
                            </td>
                            <td className="tw-border tw-border-gray-400 tw-border-l-0" />
                          </tr>
                        </tbody>
                        {/* <tfoot>
                    <tr className={'project-billing'}>
                      <th className="border border-gray-400 px-4 py-2">Totals</th>
                      <td className="border border-gray-400 px-4 py-2" />
                      <td className="border border-gray-400 px-4 py-2" />
                      <td className="border border-gray-400 px-4 py-2" />
                      <td className="border border-gray-400 px-4 py-2">
                      {totals.monday}
                      </td>
                      <td className="border border-gray-400 px-4 py-2">
                      {totals.tuesday}
                      </td>
                      <td className="border border-gray-400 px-4 py-2">
                      {totals.wednesday}
                      </td>
                      <td className="border border-gray-400 px-4 py-2" />
                    </tr>
                  </tfoot> */}
                      </table>
                      <div className="tw-space-x-4 tw-flex tw-items-center tw-justify-center tw-mt-4">
                        {selectedProject && (
                          <h2 className="text-lg font-semibold">
                            Client{' '}
                            <span className="tw-text-red-500">
                              {selectedProject?.clientNumber}
                            </span>{' '}
                            - Project{' '}
                            <span className="tw-text-red-500">
                              {selectedProject.name}
                            </span>
                          </h2>
                        )}
                        {selectedSubcode && (
                          <h2 className="text-lg font-semibold">
                            Section{' '}
                            <span className="tw-text-red-500">
                              {selectedSubcode?.name}
                            </span>{' '}
                            - Unit{' '}
                            <span className="tw-text-red-500">
                              {selectedSubcode?.section}
                            </span>
                          </h2>
                        )}
                      </div>
                      <div
                        className={
                          payPeriodValidation || hasInvoice
                            ? 'tw-hidden tw-opacity-0'
                            : 'tw-space-x-4 tw-flex tw-items-center tw-justify-start tw-mt-4'
                        }
                      >
                        {/*<button
                          className="tw-bg-green-500 tw-text-white tw-py-2 tw-px-4 tw-hover:tw-bg-green-600"
                          onClick={handleRefreshTnEToken}
                          type="button"
                        >
                          Refresh T&E Token
                        </button>*/}
                        <button
                          className="tw-bg-green-500 tw-text-white tw-py-2 tw-px-4 tw-hover:tw-bg-green-600"
                          onClick={handleSaveAll}
                          type="button"
                        >
                          Save
                        </button>
                        <div className="tw-bg-green-500 tw-text-white tw-py-2 tw-px-4 tw-hover:tw-bg-green-600">
                          <PDFDownloadLink
                              document={<TimesheetDocument data={sampleData} />}
                              fileName={'timesheet.pdf'}
                              style={{color: 'white'}}
                          >
                              {({ loading }) => (loading ? 'Loading...' : 'T/E Statement')}
                          </PDFDownloadLink>
                        </div>
                        <button
                          className="tw-bg-green-500 tw-text-white tw-py-2 tw-px-4 tw-hover:tw-bg-green-600"
                          onClick={() => getTimesheetReportFile(2)}
                          type="button"
                        >
                          Statement
                        </button>
                        <div className="tw-bg-green-500 tw-text-white tw-py-2 tw-px-4 tw-hover:tw-bg-green-600">
                        <PDFDownloadLink
                          style={{textDecoration: 'none', color: 'white'}}
                          document={
                            <SummaryDocument
                              summaries={sampleSummary}
                              date={new Date().toLocaleDateString()}
                            />
                          }
                          fileName={`TimeSheet-Summary.pdf`}
                        >
                          {({ blob, url, loading, error }) =>
                            loading ? 'Generating document...' : 'T/E Summary'
                          }
                        </PDFDownloadLink>
                        </div>
                        <button
                          type="button"
                          className={`tw-bg-green-500 tw-text-white tw-py-2 px-4 tw-hover:tw-bg-green-600`}
                          title={`Approve this timesheet.`}
                          onClick={() => handleApproveTimesheet()}
                        >
                          Approve
                        </button>
                        <button
                          type="button"
                          className={`tw-bg-green-500 tw-text-white tw-py-2 tw-px-4 tw-hover:tw-bg-green-600`}
                          title={`Clear timesheet approval.`}
                          onClick={() => handleResetTimesheet()}
                        >
                          Revoke Approval
                        </button>
                      </div>
                      {!!payPeriodValidation ||
                      !!hasInvoice ||
                      !formData?.isContractor ? (
                        <br />
                      ) : (
                        <div className="tw-flex tw-justify-center tw-items-center tw-gap-2 tw-mt-4 tw-mb-8">
                          <hr className="tw-bg-red-500 tw-w-1/4 tw-h-[2px]" />
                          <span className="tw-text-red-500 tw-text-[30px]">
                            <FiChevronDown />
                          </span>
                          <span className="tw-text-lg tw-text-red-500 tw-font-semibold">
                            This time sheet is not submitted. Please attach invoice to
                            close out pay period.
                          </span>
                          <span className="tw-text-red-500 tw-text-[30px]">
                            <FiChevronDown />
                          </span>
                          <hr className="tw-bg-red-500 tw-w-1/4 tw-h-[2px]" />
                        </div>
                      )}
                      <div
                        hidden={
                          payPeriodValidation || hasInvoice || !formData?.isContractor
                        }
                      >
                        <button
                          className="tw-bg-green-500 tw-text-white tw-py-2 tw-px-4 tw-hover:tw-bg-green-600"
                          type="button"
                          onClick={() => handleOpenInvoice()}
                        >
                          Attach Invoice and Submit
                        </button>
                      </div>
                      {hasInvoice && !payPeriodValidation && renderInvoice()}
                    </form>
                  </div>
                </div>
              )}
              {!!loadingPage && <LoadingSpinner />}
            </>
          );        
    };

    return (
        <>
        <div>
        <PBNavBar/>
            <ClientProjectSearch
                setSelectedPayPeriod={setSelectedPayPeriodValue}
                payPeriods={!!payPeriods && payPeriods.length > 0 ?
                    payPeriods?.map((pp) => { return {id: pp?.id, name: !!pp?.name ? pp?.name : ''}; }) : []}
                runQuery={loadData}
                size={6}
            />
           <div id={'TimeAndExpensePage'} style={{margin: '0 auto', display: 'flex', maxWidth: '98vw', justifyContent: 'center'}}>
                <form id={`ProjectMaintenanceForm`} onSubmit={onSubmit}>
                    <Page className="dlc-maxer-width">
                        <Page.Section width={14}>
                            <Panel backgroundColor="#D3D3D3">
                                <Panel centerPanelTitle={true} panelTitle={displayTitle()}>
                                  
                                    <div style={{marginBottom: '1rem', display: 'flex', width: '70%', justifyContent: 'center'}}>
                                        {false && displayOfficeExpenseButtons()}
                                    </div>
                                    <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                                        <div style={{ border: 'solid rgb(99, 147, 193) 1px', paddingBottom: '.5rem' }}>
                                            {!!loadingTimeEntries && (
                                                <div style={{ width: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                                                    <span>Retreiving Time Entries...</span>
                                                    <LoadingSpinner />
                                                </div>
                                            )}
                                            {!loadingTimeEntries && displayTimeSheet()}
                                        </div>
                                    </div>
                                    <div>
                                        {false && displayStaffList()}
                                    </div>
                                </Panel>
                            </Panel>
                        </Page.Section>
                    </Page>
                </form>
                <WorkAndExpenseDialog
                  compType={(timeExpenseData as { compensationTypeForPayPeriod: string })?.compensationTypeForPayPeriod}
                  activityType={!!tsdiAccounts && tsdiAccounts.length > 0 && !!billingSummary && billingSummary.length > 0 &&
                     getTsdiAccountNameFromCode(Number(!!billingSummary ? (!!billingSummary[0]?.workClassificationName ? billingSummary[0]?.workClassificationName : '') : 0))}
                  calendarDays={!!calendarDays && calendarDays.length > 0 ? calendarDays : undefined}
                  billingCode={getBillingCode()}
                  dialogName={DialogList.EDIT_TIME_AND_EXPENSE}
                  hideDialog={hideWorkExpenseDialogAndRefreshData}
                  payPeriod={!!selectedPayPeriod && selectedPayPeriod.length > 0 ? Number(selectedPayPeriod) : 202502}
                  adminToUser={!!delegatedDlcNumber}
                  setShowDeleteWarning={setShowDeleteWarning}
                  confirmDeleteDayEntry={confirmDeleteDayEntry}
                />
                <ReceiptViewerDialog
                  context={1}
                  dialogName={DialogList.RECEIPT_VIEWER}
                  handleConfirm={hideReceiptViewerDialog}
                  hideDialog={hideReceiptViewerDialog}
                  imageBase64={/*imageSrc*/undefined}
                  receipts={!!receiptThumbnails && receiptThumbnails.length > 0 ? receiptThumbnails : undefined}
                  sourceType={DocumentSourceType.OfficeExpenseReceipt}
                />
                <FlagNoteDialog 
                    dialogName={DialogList.FLAG_REASON_DIALOG} 
                    hideDialog={hideDialog}
                    handleConfirm={handleSetReasonForTimesheetReset}
                    type={2}
                />
                <WarningDialog
                    dialogName={DialogList.CONFIRM_DELETE_TIME_ENTRY}
                    hideDialog={hideWarningDialog}
                    handleConfirm={handleConfirmDeleteTimeEntry}
                    label={'All Expenses and receipts will be deleted!'}
                    message={'Click OK to delete day entry and all associated items, Cancel to abort.'}
                />
            </div>
        </div>        
        </>
    );
};

export default TimeAndExpensePageComponent;



// WEBPACK FOOTER //
// ./src/components/project-billing/pages/TimeAndExpensePageComponent.tsx